import { render, staticRenderFns } from "./treepopup.vue?vue&type=template&id=1ba5fa6b&scoped=true&"
import script from "./treepopup.vue?vue&type=script&lang=js&"
export * from "./treepopup.vue?vue&type=script&lang=js&"
import style0 from "./treepopup.vue?vue&type=style&index=0&id=1ba5fa6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba5fa6b",
  null
  
)

export default component.exports